import { GoDotFill } from 'react-icons/go';

const RequiredDocDiv = ({
  docTitle,
  docDescription,
}: {
  docTitle: string;
  docDescription: string;
}) => {
  // rendering required doc div component here
  return (
    <div className='flex items-start gap-1 text-legal-dark-blue'>
      <GoDotFill className='mt-[7px] text-base-orange size-3' />

      <div className='flex-1'>
        <p className='font-semibold'>{docTitle}</p>
        <p className='ml-1 text-sm'>{docDescription}</p>
      </div>
    </div>
  );
};

export default RequiredDocDiv;
